import { cn } from 'utils/classNames';

import { LoadingSkeletonItem } from './LoadingSkeleton';

interface Props {
	className?: string;
	orientation?: 'horizontal' | 'vertical';
	showAddToCartButton?: boolean;
}

export default function LoadingProductCardSkeletonItem({
	className,
	orientation = 'vertical',
	showAddToCartButton = false,
}: Props) {
	if (orientation === 'horizontal') {
		return (
			<div className={cn('flex gap-4', className)}>
				{/* Image */}
				<LoadingSkeletonItem className="size-24" />
				<div className="grow">
					{/* Title and subtitle */}
					<LoadingSkeletonItem
						height="2.75rem"
						width="90%"
						className="max-w-80"
					/>
					{/* Rating */}
					<LoadingSkeletonItem height="text-xs" width="7rem" className="mt-2" />
					{/* Price, with or without add to cart button */}
					{!showAddToCartButton && (
						<LoadingSkeletonItem height="3rem" width="5rem" className="mt-2" />
					)}
					{showAddToCartButton && (
						<div className="mt-2 flex justify-between gap-4">
							<LoadingSkeletonItem height="3rem" width="5rem" />
							<LoadingSkeletonItem height="3rem" width="6rem" />
						</div>
					)}
				</div>
			</div>
		);
	}
	return (
		<div className={className}>
			{/* Image */}
			<LoadingSkeletonItem className="size-40 sm:max-w-[60%]" />
			{/* Title and subtitle */}
			<LoadingSkeletonItem height="2.75rem" width="90%" className="mt-2" />
			{/* Rating */}
			<LoadingSkeletonItem height="text-xs" width="7rem" className="mt-2" />
			{/* Price and USPs */}
			<LoadingSkeletonItem height="8rem" width="75%" className="mt-2" />
			{/* Stock */}
			<LoadingSkeletonItem
				height="text-xs"
				lines={2}
				width="60%"
				className="mt-4"
			/>
			{showAddToCartButton && (
				<LoadingSkeletonItem height="2.25rem" width="5rem" className="mt-4" />
			)}
		</div>
	);
}
LoadingProductCardSkeletonItem.displayName = 'LoadingProductCardSkeletonItem';
